import { captureException } from 'marketing-site/lib/sentry'
import { TranslationsMap } from './buildTranslationsMap'
import getKeyFromString from './getKeyFromString'

export function translateFromEnglish(
  stringToTranslate: string,
  translationsMap: TranslationsMap,
): string {
  if (!stringToTranslate || translationsMap.size === 0) return stringToTranslate

  const stringKey = getKeyFromString(stringToTranslate)
  const translation = translationsMap.get(stringKey)
  if (translation) return translation

  captureException(new Error(`Translation not found for ${stringToTranslate}`))

  return stringToTranslate
}
